import {
  Download1GoIcon,
  DownloadBlackIcon,
  DownloadDripIcon,
  DownloadGreenIcon,
  DownloadGreyIcon,
  DownloadIcon,
  DownloadIzziIcon,
  DownloadMonroIcon,
} from '@p2p/assets/svg';
import { FC, useMemo } from 'react';

import styles from './TransferHead.module.scss';

interface ITransferHeadProps {
  id: string;
  status: string;
}

export const TransferHead: FC<ITransferHeadProps> = ({ id, status }) => {
  const icon = useMemo(() => {
    switch (status) {
      case 'starda':
        return <DownloadGreenIcon />;
      case 'jet':
        return <DownloadGreyIcon />;
      case 'izzi':
        return <DownloadIzziIcon />;
      case 'legzo':
        return <DownloadIzziIcon />;
      case 'drip':
        return <DownloadDripIcon />;
      case 'fresh':
        return <DownloadBlackIcon />;
      case 'onego':
        return <Download1GoIcon />;
      case 'monro':
        return <DownloadMonroIcon />;
      default:
        return <DownloadIcon />;
    }
  }, [status]);

  return (
    <div className={styles[status]}>
      <div className={styles.payment_dialog__header}>
        <div className={styles.payment_dialog__header_title}>
          {icon}
          <span className={styles.payment_dialog__header_description}>Пополнение</span>
        </div>
        <div className={styles.payment_dialog__header_id}>
          <span className={styles.payment_dialog__header_id_text}>ID заказа:</span>
          <span className={styles.payment_dialog__header_id_number}>{id}</span>
        </div>
      </div>
    </div>
  );
};
